<template>
    <aside class="sidebar" v-if="hasContent">
        <portal-target class="portal-target" name="sidebar"></portal-target>
    </aside>
</template>

<script>
import {Wormhole} from 'portal-vue'

export default {
    computed: {
        hasContent() {
            return Wormhole.hasContentFor('sidebar')
        }
    }
}
</script>